import { Grid, GridItem, chakra, Heading, Button, Flex, useBreakpointValue } from "@chakra-ui/react";
import * as React from "react";
import { LeverGridItem, PathwayGridItem } from "./components";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

const mapServerDataToFormData = (leversData) => {
  const formData = {};

  leversData.forEach(lever => {
    lever.subLevers.forEach(subLever => {
      subLever.selections.forEach(selection => {
        formData[`lever-${lever.id}-sub-lever-${subLever.id}-pathway-${selection.pathwayId}`] = selection.selected;
      });
    });
  });

  return formData;
};

function Pathways({ data, handleSwitchChange, handleModalOpen, isDemo = false }) {
  const { pathways, levers } = data;
  const { t } = useTranslation("translation", {
    keyPrefix: "decarbonization"
  });
  const leversDisplay = useBreakpointValue({
    base: "block",
    sm: "flex",
  });
  const setParamsBtnLabel = useBreakpointValue({
    base: t("page.setParameters"),
    "2xl": t("page.setParameters"),
    xl: t("page.set"),
  });

  const {
    register,
    control,
    reset
  } = useForm({
    defaultValues: mapServerDataToFormData(levers)
  });

  useEffect(() => {
    if (data) {
      reset(mapServerDataToFormData(levers));
    }
  }, [data, reset, levers]);

  return (
    <chakra.form>
      <Grid templateColumns="repeat(19, 1fr)" gap={3}>
        <GridItem colSpan={9} height={16}>
          <Flex alignItems="center" gap={5} height="100%" display={leversDisplay}>
            <Heading fontSize="2xl">{t("page.levers")}</Heading>
            <Button
              colorScheme="white"
              color="esg_lightgreen"
              border={"1px solid"}
              borderColor={"esg_lightgreen"}
              onClick={handleModalOpen}
              height="fit-content"
              paddingTop={1}
              paddingBottom={1}
              isDisabled={isDemo}
            >
              {setParamsBtnLabel}
            </Button>
          </Flex>
        </GridItem>
        {pathways && pathways.map(pathway => {
          return <PathwayGridItem key={`pathway-${pathway.id}`} name={pathway.name?.toLowerCase() ?? ""} />;
        })}
        {levers && levers.map((lever, leverIndex) => {
          return <LeverGridItem
            key={`lever-${lever.id}`}
            lever={lever}
            leverIndex={leverIndex}
            register={register}
            control={control}
            submitSwitchChange={handleSwitchChange}
          />;
        })}
      </Grid>
    </chakra.form>
  );
}

export default Pathways;